// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3awRt","disabled":"FileBtn_disabled__1LACC","warn":"FileBtn_warn__1RtNR","fade":"FileBtn_fade__28rWP"};